<main>
  <section style="padding-top: 140px;">
    <div class="container">
      <div class="row justify-center text-center">
        <div class="col-auto">
          <div class="sectionTitle -md">
            <h2 class="sectionTitle__title">Seyahat Makaleleri</h2>
            <p class="sectionTitle__text mt-5 sm:mt-0">Bir sonraki seyahatiniz için ilham alın.</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="layout-pt-md layout-pb-lg">
    <div class="container">
      <div class="row y-gap-30 justify-between">
        <div class="col-xl-8">
          <!-- Loading State -->
          <div *ngIf="loading" class="row y-gap-30">
            <div class="col-12 text-center py-50">
              <div class="text-18 text-dark-1">Yükleniyor...</div>
            </div>
          </div>

          <!-- Error State -->
          <div *ngIf="error && !loading" class="row y-gap-30">
            <div class="col-12 text-center py-50">
              <div class="text-18 text-red-1">{{ error }}</div>
              <button (click)="loadBlogs()" class="button -blue-1 mt-20">Tekrar Dene</button>
            </div>
          </div>

          <!-- Blog List -->
          <div *ngIf="!loading && !error" class="row y-gap-30">
            <a 
              *ngFor="let blog of blogs; let i = index" 
              [routerLink]="['/blog', blog.slug]" 
              class="blogCard -type-1 col-12">
              <div class="row y-gap-15 items-center md:justify-center md:text-center">
              <div class="col-auto">
                <div class="blogCard__image rounded-4">
                  <div class="ratio ratio-1:1 w-250">
                    <img [src]="getBlogImage(blog, i)" [alt]="blog.name" class="img-ratio rounded-4">
                  </div>
                </div>
              </div>

                <div class="col-md">
                  <div class="text-15 text-light-1" *ngIf="blog.publishedDate">
                    {{ formatDate(blog.publishedDate) }}
                  </div>

                  <h3 class="text-22 text-dark-1 mt-10 md:mt-5">
                    {{ blog.name }}
                  </h3>

                  <div class="text-15 lh-16 text-light-1 mt-10 md:mt-5">
                    {{ getShortDescription(blog.content) }}
                  </div>
                </div>
              </div>
            </a>

            <!-- Empty State -->
            <div *ngIf="blogs.length === 0" class="col-12 text-center py-50">
              <div class="text-18 text-light-1">Henüz blog yazısı bulunmamaktadır.</div>
            </div>
          </div>

          <!-- Pagination -->
          <div *ngIf="!loading && !error && blogs.length > 0" class="border-top-light mt-30 pt-30">
            <div class="row x-gap-10 y-gap-20 justify-between md:justify-center">
              <div class="col-auto md:order-1">
                <button class="button -blue-1 size-40 rounded-full border-light">
                  <i class="icon-chevron-left text-12"></i>
                </button>
              </div>

              <div class="col-md-auto md:order-3">
                <div class="row x-gap-20 y-gap-20 items-center md:d-none">
                  <div class="col-auto">
                    <div class="size-40 flex-center rounded-full">1</div>
                  </div>
                  <div class="col-auto">
                    <div class="size-40 flex-center rounded-full bg-dark-1 text-white">2</div>
                  </div>
                  <div class="col-auto">
                    <div class="size-40 flex-center rounded-full">3</div>
                  </div>
                  <div class="col-auto">
                    <div class="size-40 flex-center rounded-full bg-light-2">4</div>
                  </div>
                  <div class="col-auto">
                    <div class="size-40 flex-center rounded-full">5</div>
                  </div>
                  <div class="col-auto">
                    <div class="size-40 flex-center rounded-full">...</div>
                  </div>
                  <div class="col-auto">
                    <div class="size-40 flex-center rounded-full">20</div>
                  </div>
                </div>

                <div class="row x-gap-10 y-gap-20 justify-center items-center d-none md:d-flex">
                  <div class="col-auto">
                    <div class="size-40 flex-center rounded-full">1</div>
                  </div>
                  <div class="col-auto">
                    <div class="size-40 flex-center rounded-full bg-dark-1 text-white">2</div>
                  </div>
                  <div class="col-auto">
                    <div class="size-40 flex-center rounded-full">3</div>
                  </div>
                </div>

                <div class="text-center mt-30 md:mt-10">
                  <div class="text-14 text-light-1">1 – {{ blogs.length }} of {{ blogs.length }}+ properties found</div>
                </div>
              </div>

              <div class="col-auto md:order-2">
                <button class="button -blue-1 size-40 rounded-full border-light">
                  <i class="icon-chevron-right text-12"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Sidebar -->
        <div class="col-xl-3">
          <div data="slide-up delay-3" class="sidebar -blog">

            <div class="sidebar__item">
              <h5 class="text-18 fw-500 mb-10">Son Makaleler</h5>
          <div class="row y-gap-20 pt-10" *ngIf="blogs.length > 0">
            <div class="col-12" *ngFor="let blog of blogs.slice(0, 3); let i = index">
              <a [routerLink]="['/blog', blog.slug]" class="d-flex items-center">
                <img class="size-65 rounded-8" [src]="getBlogImage(blog, i)" [alt]="blog.name">
                <div class="ml-15">
                  <h5 class="text-15 lh-15 fw-500">{{ blog.name }}</h5>
                  <div class="text-13 lh-1 mt-5" *ngIf="blog.publishedDate">
                    {{ formatDate(blog.publishedDate) }}
                  </div>
                </div>
              </a>
            </div>
          </div>
              <div *ngIf="blogs.length === 0" class="text-14 text-light-1 pt-10">
                Henüz blog yazısı bulunmamaktadır.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <app-newsletter></app-newsletter>
</main>

